import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import emailjs from 'emailjs-com';
import SchoolPaymentSuccess from './SchoolPaymentSuccess';

const db = getFirestore();
const auth = getAuth();

const accountTypeMap = {
  ab12cd34ef56gh78ij90: 'basic',
  zx98yv76wu54ts32rq10: 'pro',
  hy34jd45tk67lm89op00: 'hybrid',
  xy12kz34mn56op78qr90: 'enterprise',
  sc23pl45mn67kj89qr00: 'school',
};

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { accountToken } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isSchoolMembership =
    accountToken === 'sc23pl45mn67kj89qr00' ||
    localStorage.getItem('pendingSchoolMembershipId') !== null;

  // — hooks must always be at the top level —
  useEffect(() => {
    if (isSchoolMembership) {
      // don’t run Firestore/email logic for school plans
      setLoading(false);
      return;
    }

    const updatePaymentStatus = async () => {
      try {
        const user = auth.currentUser;
        if (!user) throw new Error('User not authenticated.');

        const accountType = accountTypeMap[accountToken];
        if (!accountType) throw new Error('Invalid token.');

        await updateDoc(doc(db, 'users', user.uid), {
          paymentStatus: 'paid',
          account: accountType,
        });

        // send email
        const templateParams = {
          name: 'Payment System',
          email: user.email,
          message: `The user ${user.email} has subscribed to the ${accountType} plan.`,
        };
        await emailjs.send(
          'service_rpg9tsq',
          'template_t06rk76',
          templateParams,
          '2c0CoID2ucNYaKVFe'
        );

        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(err.message);
        setLoading(false);
      }
    };

    updatePaymentStatus();
  }, [isSchoolMembership, accountToken, navigate]);

  // now it’s safe to early-return
  if (isSchoolMembership) {
    return <SchoolPaymentSuccess />;
  }

  if (loading) {
    return <div className="loader">Updating payment status...</div>;
  }

  return (
    <div className="payment-success-container">
      {error ? (
        <div className="error-message">{error}</div>
      ) : (
        <>
          <h2>Payment Successful!</h2>
          <p>{getMessage(accountToken)}</p>
          <div className="button-container">
            <button onClick={() => navigate('/dashboard')}>Go Home</button>
          </div>
        </>
      )}
    </div>
  );
};

function getMessage(token) {
  switch (token) {
    case 'ab12cd34ef56gh78ij90':
      return 'Thank you for subscribing to the Basic plan. Enjoy full access to Nur Al Huda.';
    case 'zx98yv76wu54ts32rq10':
      return 'Thank you for subscribing to the Pro plan. Enjoy full access to Nur Al Huda, Islamic Socratic Method, Iqra with Us, and more!';
    case 'hy34jd45tk67lm89op00':
      return 'Thank you for subscribing to the Hybrid plan. Enjoy full access to Nur Al Huda and Nur Al Huda for Kids!';
    case 'xy12kz34mn56op78qr90':
      return 'Thank you for subscribing to the Premium plan. Experience all our exclusive features tailored for enterprises!';
    default:
      return 'Thank you for your purchase.';
  }
}

export default PaymentSuccess;
